import React from 'react'
import { Box, IconButton } from '@material-ui/core'
import { useStyles } from '../SchoolShow_style'
import SVGFactory from 'icons/SVGFactory/SVGFactory'

const SchoolSocialLinks = (props) => {
    const { school } = props
    const classes = useStyles()

    return (
        <Box className={classes.iconsContainer}>
            {school.url &&
                <IconButton href={school.url} target='_blank' rel='noopener noreferrer' className={classes.iconButton}>
                    <SVGFactory skipSvgWrapper height='20' width='20' name='impact' />
                </IconButton>
            }
            {school.url_tiktok &&
                <IconButton href={school.url_tiktok} target='_blank' rel='noopener noreferrer' className={classes.iconButton}>
                    <SVGFactory skipSvgWrapper height='20' width='20' name='tiktok' />
                </IconButton>
            }
            {school.url_linkedin &&
                <IconButton href={school.url_linkedin} target='_blank' rel='noopener noreferrer' className={classes.iconButton}>
                    <SVGFactory skipSvgWrapper height='20' width='20' name='linkedin' />
                </IconButton>
            }
            {school.url_instagram &&
                <IconButton href={school.url_instagram} target='_blank' rel='noopener noreferrer' className={classes.iconButton}>
                    <SVGFactory skipSvgWrapper height='20' width='20' name='instagram' />
                </IconButton>
            }
            {school.url_facebook &&
                <IconButton href={school.url_facebook} target='_blank' rel='noopener noreferrer' className={classes.iconButton}>
                    <SVGFactory skipSvgWrapper height='20' width='20' name='facebook' />
                </IconButton>
            }
        </Box>
    )
}

export default SchoolSocialLinks
